import React, {Component} from 'react';
import { Link } from 'react-router';
import Helmet from "react-helmet";

import GuideButton from '../../components/GuideButton';
import GuideHeader from '../../components/GuideHeader';

export default class Ventilation extends Component {
  render() {
    const imageUrl = "https://blacksquare.nyc3.digitaloceanspaces.com/janes_colony/guide/guide_header_flowering_2.jpg";
    return (
      <div>
        <Helmet
          title="Jane's Colony"
          meta={ [
            { name: "description", content: "" },
            { property: "og:title", content: ''},
            { property: "og:url", content: ''},
            { property: "og:image", content: ''},
          ] }
        />
        <GuideHeader imageUrl={imageUrl} />
        <h2>
          Ventilation
        </h2>
        <p>
          Marijuana plants need fresh air. Plan on having both intake and exhaust fans as well as several oscillating fans inside the grow space to move air around. Heat rises so it’s important to force the heat collecting in the top of your grow room outside. Exhaust from the top and intake from to the lowest possible point of your grow room or grow tent. Having a minimum of 2 oscillating fans pointed towards the bottom and top of your plant will help move air from between foliage and prevent pockets of disease-friendly environments within your canopy. If possible, don’t intake from the same room you’re exhausting from. 
        </p>
        <p>
          Growing marijuana can be a smelly affair. If you’re concerned about the smell, adding a carbon filter to scrub the air will leave your grow room undetected by sensitive noses.
        </p>
        <p>
          It is not necessary to run your fans 24/7. Depending on your temperature and humidity levels, you can have them run at any schedule that works for you. Setting up a timer for your fans is an easy and effective way to save on your electricity bill.
        </p>
        <GuideButton slugTo="pest-control" />
      </div>
    )
  }
}





// WEBPACK FOOTER //
// ./src/content/guide/one_ventilation.js